import React from 'react';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import {
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormFeedback,
} from 'reactstrap';
import { Input } from '@/components/Input';
import { Link } from 'react-router-dom';
import { Button, buttonVariants } from '@/components/Button';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import styles from './Login.module.scss';
const renderField = ({
  input,
  icon,
  type,
  placeholder,
  label,
  className,
  meta: { touched, error },
}) => {
  return (
    <Input
      inputLabelClassName={styles.inputLabel}
      label={label}
      errorMessage={touched && error ? error : ''}
      type={type}
      {...input}
      placeholder={placeholder}
    />
  );
};
const Form = ({ submitting, handleSubmit, onSubmit }) => {
  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.loginForm}>
      <Field
        icon="ni ni-email-83"
        placeholder="example@email.com"
        type="email"
        label="WORK EMAIL"
        name="email"
        className="mb-3"
        component={renderField}
      />
      <Field
        icon="ni ni-lock-circle-open"
        placeholder="Enter your password"
        type="password"
        label="PASSWORD"
        name="password"
        component={renderField}
      />

      <div className="custom-control custom-control-alternative custom-checkbox">
        <input
          className="custom-control-input"
          id=" customCheckLogin"
          type="checkbox"
        />
        <label className="custom-control-label" htmlFor=" customCheckLogin">
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Semibold}
            style={{ color: '#23272C' }}
          >
            Remember me
          </Text>
        </label>
      </div>
      <div
        className={styles.loginFormButtonContainer}
        style={{ marginTop: '24px' }}
      >
        <Button
          variant={buttonVariants.primary_light}
          className={styles.loginFormButton}
          type="submit"
          text="Sign in"
          loading={submitting}
          disabled={submitting}
        />
      </div>
      <div className={styles.loginFooter}>
        <div className="text-center mt-2">
          <Text
            variant={textVariantsEnum.Text_15}
            fontWeight={fontWeightEnum.Semibold}
            style={{ color: '#23272C' }}
          >
            Forgot password ? <Link to="/auth/forgot-password">Reset</Link>
          </Text>
        </div>
        <div className={styles.loginFooterSeparator} />
        <div className="text-center mt-2">
          <Text
            variant={textVariantsEnum.Text_15}
            fontWeight={fontWeightEnum.Semibold}
            style={{ color: '#23272C' }}
          >
            Don't have an account? <Link to="/auth/sign-up">Sign up Now</Link>
          </Text>
        </div>
      </div>
    </form>
  );
};

Form.propTypes = {
  onSubmit: PropTypes.func,
};

Form.defaultProps = {
  onSubmit: () => {},
};
const validate = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address';
  }
  if (!values.password) {
    errors.password = 'Required';
  }
  return errors;
};
export default reduxForm({
  form: 'loginForm',
  validate,
})(Form);
